module.exports = __webpack_public_path__ + "static/media/Birth and Bloom.a5719a60.png";